/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/new-contact',
  name: 'ErterbatOld',
  component: () => import('@/views/ertebat/Old'),
},
{
  path: '/contacts',
  name: 'ErtebatHistory',
  component: () => import('@/views/ertebat/Index'),
},
{
  path: '/new-contact-v2',
  name: 'ErterbatNew',
  component: () => import('@/views/ertebat/New'),
},
]

